module.exports = "<div role=\"tabpanel\" class=\"tab-pane\" [id]=\"id\">\r\n    <span *ngIf='active'>\r\n        <ng-content></ng-content>\r\n    </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/tabs/tab-item.component.html
// module id = ../../../../../app/shared/components/tabs/tab-item.component.html
// module chunks = main